/**
 * Alert trigger evaluation - derives which ACTIVE price alerts have actually
 * crossed their threshold, from the latest observed local prices. Pure
 * function over real records: nothing is invented, paused alerts never
 * trigger, and an alert with no price data stays silent.
 *
 * "All markets (any)" semantics: the alert triggers if ANY market's newest
 * observation crosses the threshold; the most extreme crossing is reported.
 */

export function evaluateAlerts(alerts, localPrices) {
  const triggered = [];
  for (const a of alerts || []) {
    if (a.status !== 'active') continue;

    const rows = (localPrices || []).filter(
      (p) => p.commodityId === a.commodityId && (a.marketId === 'all' || p.marketId === a.marketId)
    );
    if (rows.length === 0) continue;

    // Newest observation per market
    const latestByMarket = new Map();
    for (const p of rows) {
      const prev = latestByMarket.get(p.marketId);
      if (!prev || p.date > prev.date) latestByMarket.set(p.marketId, p);
    }

    let hit = null;
    for (const p of latestByMarket.values()) {
      const observed = a.unit === 'kg' ? p.pricePerKg : p.price;
      if (observed == null) continue;
      const crossed = a.direction === 'below' ? observed < a.threshold : observed > a.threshold;
      if (!crossed) continue;
      const moreExtreme = hit && (a.direction === 'below' ? observed < hit.observed : observed > hit.observed);
      if (!hit || moreExtreme) hit = { observed, marketId: p.marketId, date: p.date };
    }

    if (hit) {
      triggered.push({
        alert: a,
        observedPrice: hit.observed,
        marketId: hit.marketId,
        observedDate: hit.date,
      });
    }
  }
  return triggered;
}
